/* eslint-disable react/no-danger */
import React from 'react';
import moment from 'moment';
import get from 'lodash/get';
import find from 'lodash/find';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  externalOfferOrderAmountPath, externalOfferOrderDeliveryPath,
  externalOfferOrderTransferPath,
} from '../../Forms/Schemas/baseRrf';
import BaseDetailScreen from '../../BaseDetailScreen';
import Button from '../../Button';
import LabeledRow from '../components/LabeledRow';
import { formatCurrency } from '../../Currency';
import { formatQuantity } from '../..//SecurityDetail/SecurityDetail';
import './styles.css';

// should show payment information
const Component = ({
  bankLinks,
  offer,
  user,
  offerOrderAmount,
  offerOrderTransferFunds,
  onNext,
  isConditional,
  deliveryInformation,
}) => {
  const transferBank = find(bankLinks, { bankLinkOid: offerOrderTransferFunds.from });
  let back = {
    label: 'Funding Info',
    to: `/external-invest/${offer.id}/delivery`,
  };
  let transferDetails;
  if (offerOrderTransferFunds.transferAmount) {
    back = {
      label: 'Edit Transfer',
      to: `/external-invest/${offer.id}/payment`,
    };

    transferDetails = (
      <div styleName="transferDetails">
        <div styleName="transferReviewBreakTop" />
        <LabeledRow
          label="From"
          value={transferBank.bankName}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={transferBank.bankAccountNumber}
        />
        <LabeledRow
          label="Transfer Amount"
          value={`${formatCurrency(Number.parseFloat(offerOrderTransferFunds.transferAmount))}`}
        />
        <div styleName="transferReviewBreakBottom" />
      </div>
    );
  }

  return (
    <BaseDetailScreen
      backLabel={back.label}
      backTo={back.to}
      pageHeading="Review Order"
      pageSubheading="Please review the order below before completing the order process."
    >
      <div styleName="reviewOrderHeader">
        {offer.name}
      </div>
      <div styleName="reviewMain">
        <LabeledRow
          label="Investor Name"
          value={`${user.identity.firstName} ${user.identity.lastName}`}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label="Address"
          value={user.identity.primaryAddress.line1}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={`${user.identity.primaryAddress.city} ${user.identity.primaryAddress.state}, ${user.identity.primaryAddress.zipcode}`}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label="Date"
          value={moment().format('ll')}
          modifiedStyle="addressRow"
        />
        <div styleName="bankInfo">
          <div styleName="head">Wiring Instruction</div>
          <div styleName="table">
            <table style={{ width: '100%' }}>
              <tbody>
                <tr styleName="spaceUnder">
                  <td>Bank Name:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrBankName }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>ABA #:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrABANumber }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>A/C #:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAccountNumber }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>A/C Name:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAccountName }} /></td>
                </tr>
                <tr styleName="spaceUnder">
                  <td>Attn:</td>
                  <td><span dangerouslySetInnerHTML={{ __html: offer.wiringInstrAttentionLine }} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <LabeledRow
          label="Security Delivery Instruction:"
          value={deliveryInformation.delivery}
          modifiedStyle="addressRow"
        />
        {
          isConditional ?
            <LabeledRow
              label="Offering Category"
              value={offer.categoryName}
            /> : null
        }
        {
          isConditional ?
            <LabeledRow
              label="Share Range"
              value={`${formatCurrency(offer.minSharePrice)} - ${formatCurrency(offer.maxSharePrice)}`}
              modifiedStyle="addressRow"
            /> :
            <div>
              <LabeledRow
                label="Quantity"
                value={formatQuantity(Number.parseFloat(offerOrderAmount.quantity))}
                modifiedStyle="addressRow"
              />
              <LabeledRow
                label="Share Price"
                value={offer.pricePerShare}
                modifiedStyle="addressRow"
                isCurrency
              />
            </div>
        }
        { offerOrderTransferFunds.transferAmount ?
            transferDetails :
            <div styleName="breakLineTotal" style={{ width: '466px' }} />
        }
        <LabeledRow
          label="Total Investment"
          value={Number.parseFloat(offerOrderAmount.requestedDollarAmount)}
          modifiedStyle="addressRow"
          style={{
            fontFamily: 'Source Sans Pro',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '20px',
            lineHeight: '25px',
            letterSpacing: '0.25px',
          }}
          isCurrency
        />
        <div styleName="acknowledge" style={{ padding: '0 10px' }}>
          By clicking &quot;Place Order&quot;, I acknowledge the&nbsp;
          <Link
            styleName="disclaimerLink"
            to={`/external-invest/${offer.id}/terms-and-conditions`}
          >
            terms and conditions.
          </Link>
        </div>
        <div styleName="submitButtonContainer">
          <Button onClick={onNext}>
            Place Order
          </Button>
        </div>
      </div>
    </BaseDetailScreen>
  );
};

Component.displayName = 'ReviewOrder';

Component.defaultProps = {
  investment: {
    totalInvestment: 0.00,
  },
};

const mapStateToProps = state => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  user: state.user.data,
  offerOrderAmount: get(state, externalOfferOrderAmountPath),
  deliveryInformation: get(state, externalOfferOrderDeliveryPath),
  offerOrderTransferFunds: get(state, externalOfferOrderTransferPath),
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/InvestmentViews/ReviewOrder.js